import { Grid } from '@mui/material';
import { SwitchElement, TextFieldElement, useFormContext } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';

export const EfficiencyField = () => {
  const { formatMessage } = useIntl();
  const { watch } = useFormContext();
  const enableEfficiency = watch('enableEfficiency');

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SwitchElement
          name="enableEfficiency"
          label={formatMessage({
            id: 'audit.aod.exportConditions.enableEfficiency',
            defaultMessage: 'Verificar eficiencia mínima',
          })}
        />
      </Grid>
      {enableEfficiency && (
        <Grid item xs={12} md={6}>
          <TextFieldElement
            name="minEfficiency"
            type="number"
            label={formatMessage({
              id: 'audit.aod.exportConditions.minEfficiency',
              defaultMessage: 'Eficiencia mínima',
            })}
            placeholder={formatMessage({
              id: 'audit.aod.exportConditions.minEfficiency.placeholder',
              defaultMessage: '0 - 100',
            })}
            inputProps={{
              min: 0,
              max: 100,
              step: 1,
            }}
            helperText={formatMessage({
              id: 'audit.aod.exportConditions.minEfficiency.help',
              defaultMessage: 'Eficiencia mínima (0 a 100%)',
            })}
            fullWidth
          />
        </Grid>
      )}
    </Grid>
  );
};
